import {api} from "@/shared/api";

import {AddTerminalDialog} from "@/features/terminal/addTerminalDialog";
import * as Button from "@/shared/utils/button";
import {WorkingTimeType} from "@/shared/timr";


export class TerminalOnboardingWidget extends HTMLElement {

	private addTerminalDialog: AddTerminalDialog;
	private connectTerminalBtn: HTMLElement;

	public connectedCallback(): void {
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="flex-row">
						<div class="flex-column-auto">
							<div class="panel-heading">
								<h4 class="panel-title">${messages["onboardingDashboard.terminal.title"]}</h4>
							</div>
							<div class="panel-body pt-0">
								<ul class="mb-0">
									${messages["onboardingDashboard.terminal.body"]}
								</ul>
								${messages["onboardingDashboard.terminal.learnMore"]}
								<button data-connect-terminal="" class="btn btn-primary mt-20 ml-20">${messages["onboardingDashboard.terminal.connect"]}</button>
							</div>
						</div>
						<div class="flex-column pt-20 pr-20">
							<img class="pull-right" src="/timr/images/onboarding/terminal_${globals.language}.png" alt="" height="120px">
						</div>
					</div>
				</div>`;
		this.connectTerminalBtn = this.querySelector("[data-connect-terminal]");
		this.initTerminalDialog();
	}

	private initTerminalDialog(): void {
		Button.setLoading(this.connectTerminalBtn);
		void api("onboarding/workingTimeTypesForTerminal.json")
			.get()
			.done((response: WorkingTimeType[]) => {
				this.addTerminalDialog = new AddTerminalDialog({minuteBasedWorkingTimeTypes: response});
				Button.resetLoading(this.connectTerminalBtn);
				this.connectTerminalBtn?.addEventListener("click", () => this.connectTerminal());
			});
	}

	private connectTerminal(): void {
		this.addTerminalDialog?.open(null);
	}

}
